export function isIndex(prizeTierIndex: number | null | undefined): boolean {
  return prizeTierIndex !== undefined && prizeTierIndex !== null;
}
